import { Controller } from "@hotwired/stimulus"
import { NativelyInfo, NativelyNotifications } from "natively"
import { FetchRequest } from "@rails/request.js"

// Registers the device's OneSignal subscription with the backend when the site
// runs inside the Natively mobile app. Does nothing in a regular browser.
export default class extends Controller {
  static values = { url: String, userId: String }

  connect() {
    if (!this.isNativeApp || sessionStorage.getItem(this.cacheKey)) return

    const notifications = new NativelyNotifications()
    notifications.requestPermission(false, ({ status }) => {
      notifications.getOneSignalId(({ playerId }) => {
        if (playerId) this.register(playerId, status)
      })
    })
  }

  async register(oneSignalId, authorized) {
    const request = new FetchRequest("patch", this.urlValue, {
      body: JSON.stringify({
        push_subscription: { one_signal_id: oneSignalId, authorized: authorized, os_name: this.osName }
      }),
      contentType: "application/json"
    })
    const response = await request.perform()

    if (response.ok) sessionStorage.setItem(this.cacheKey, "registered")
  }

  // Scoped per user so that an account switch inside the same app session still
  // registers the new user (and claims the device back from the previous one).
  get cacheKey() {
    return `push-subscription-${this.userIdValue}`
  }

  get isNativeApp() {
    return new NativelyInfo().browserInfo().isNativeApp
  }

  get osName() {
    if (window.natively.isIOSApp) return "ios"
    if (window.natively.isAndroidApp) return "android"
    return "unknown"
  }
}
